exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".confirm-profile__timer-message[data-v-4943f724] {\n  margin: 16px 0;\n}\n", "", {"version":3,"sources":["/home/webuser/ricoh2/releases/28/spa/src/pages/auth/confirmProfile/ConfirmProfile.scss"],"names":[],"mappings":"AACE;EACE,eAAA;CAAc","file":"ConfirmProfile.scss?vue&type=style&index=0&id=4943f724&lang=scss&scoped=true&","sourcesContent":[".confirm-profile {\n  &__timer-message {\n    margin: 16px 0;\n  }\n}"],"sourceRoot":""}]);

// exports
